import { IWebView } from '../webview/useWebViewStore';
import { MESSAGES } from './channelMessage.types';

export function resolveTargetOrigin(originOrUrl?: string): string | null {
  if (!originOrUrl) return null;
  try { return new URL(originOrUrl).origin; } catch { return null; }
}

export function urlsMatch(urlA: string, urlB: string): boolean {
  try {
    const a = new URL(urlA).href.replace(/\/$/, '');
    const b = new URL(urlB).href.replace(/\/$/, '');
    return a === b;
  } catch { return urlA === urlB; }
}

export function extractPathFromUrl(url: string): string {
  try {
    const p = new URL(url);
    return `${p.pathname}${p.search}${p.hash}`;
  } catch { return ''; }
}

export function extractOriginFromUrl(url: string): string {
  try { return new URL(url).origin; } catch { return ''; }
}

export function getRestoreUrlForView(view: IWebView): string | null {
  if (view?.visitedPath) {
    try { return new URL(view.visitedPath, view.visitedOrigin || view.url).href; } catch {}
  }
  return view?.url || null;
}

export function pathToBreadcrumb(path: string): string {
  return path
    .split('/')
    .filter(Boolean)
    .map((seg) => seg.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' '))
    .join(' > ');
}

export function readOktaTokenStorage(): any {
  const raw = localStorage.getItem('okta-token-storage');
  try { return raw ? JSON.parse(raw) : {}; } catch { return {}; }
}

export function isReloadNavigation(): boolean {
  const entry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  return entry?.type === 'reload';
}

export function postTokenMessage(id: string, appOrigin: string, unifyOrigin: string): void {
  const stored = readOktaTokenStorage();
  const frmEl = document.getElementById(id) as HTMLIFrameElement;
  if (!frmEl) { console.warn('[Unify] postTokenMessage - iframe not found:', id); return; }
  let targetOrigin: string;
  try { targetOrigin = new URL(appOrigin || frmEl.src).origin; }
  catch { console.warn('[Unify] postTokenMessage - invalid origin:', id, appOrigin); return; }
  frmEl.contentWindow?.postMessage(
    { id, action: MESSAGES.UNIFY_TOKEN_RESPONSE, payload: { accessToken: stored?.accessToken, idToken: stored?.idToken }, origin: unifyOrigin },
    targetOrigin
  );
}
